import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/app-state';


@Component({
  selector: 'app-guard',
  templateUrl: './guard.component.html',
  styleUrls: ['./guard.component.scss']
})
export class GuardComponent {

  auth: boolean;


  constructor(private store: Store<AppState>) {
    this.store.subscribe(state => {
      this.auth = state.user.isAuth;
    });
  }

  allow() {
    return this.auth;
  }



}



// WEBPACK FOOTER //
// ./src/app/core/component/core/guard/guard.component.ts